import { Typography } from '@mui/material'
import { Breadcrumbs } from '@mui/material'
import React,{useEffect, useState} from 'react'
import { Link } from 'react-router-dom'
import Exercise from './Exercise'

import axios from 'axios'
import { BASE_URL } from '../../../constants'

function ExerciseList() {

   const [exerciseData, setExerciseData] = useState([]);

    useEffect(()=>{
    axios.get(`${BASE_URL}/programs/exercise`, { 
      headers: {
        "authorization": `${localStorage.getItem('token')}` ,
        "Content-Type": "application/json",
      }}).then((res) => {
        setExerciseData(res.data)
  })
   },[])

  return (
    <div className='full-container'>
        <div style={{margin:'0px 10px'}}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" to="/programs" >
                  Program
              </Link>
              <Typography  color="text.primary">Exercise</Typography>
            </Breadcrumbs>
        </div>
        <div style={{minHeight:420}}>
          {exerciseData && exerciseData.length > 0 && exerciseData.map((exercise)=>{
              return <Exercise exercise={exercise} />
            })
          }
          {exerciseData && exerciseData.length <= 0 && <div style={{
                  display:'flex', 
                  backgroundColor:'#def1fc', 
                  border:'solid 1px #ccc',
                  margin:'10px 0px'
              }}
              >
                <div style={{width: '20%', display:'flex', padding: '5px', flexDirection:'column', alignItems:'center'}}>
                  <Typography sx={{fontSize:'16px'}} > No exercise to display. </Typography>
                </div>
              </div>
          }
        </div>
    </div>
  )
}

export default ExerciseList